import React from "react";
import * as Styles from "./ThreeSixtyOverlay.styles";
import type { UscDispatchType } from "../../../../redux/store";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_USC_THREE_SIXY_SPIN } from "../../../../utils/modalConstants";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const ThreeSixtyOverlay = (): JSX.Element => {
    const dispatch = useDispatch<UscDispatchType>();

    return (
        <Styles.CenteredOverlay>
            <Styles.ThreeSixtyIcon
                onClick={(event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    dispatch(showModal({ type: MODAL_USC_THREE_SIXY_SPIN }));
                }}
            >
                360°
            </Styles.ThreeSixtyIcon>
        </Styles.CenteredOverlay>
    );
};

export default ThreeSixtyOverlay;
